"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Review = exports.Report = exports.Ratings = exports.DropZone = void 0;
var _maplibreGl = require("maplibre-gl");
let Ratings = exports.Ratings = /*#__PURE__*/function (Ratings) {
  Ratings[Ratings["Useful"] = 5] = "Useful";
  Ratings[Ratings["NotUseful"] = 1] = "NotUseful";
  return Ratings;
}({});
class Review {
  constructor(id, created, creator, comment, rating) {
    this.id = id;
    this.created = created;
    this.creator = creator;
    this.comment = comment;
    this.rating = rating;
  }
}
exports.Review = Review;
class DropZone {
  constructor(id, created, updated, title, description, geoPoint, geometry, capacity) {
    this.id = id;
    this.created = created;
    this.updated = updated;
    this.title = title;
    this.description = description;
    this.geoPoint = geoPoint;
    this.geometry = geometry;
    this.capacity = capacity;
  }
}
exports.DropZone = DropZone;
class Report {
  constructor(id, created, updated, creator, description, geoPoint, address, city, photoUrl, source, status, typeCode, reviews, startDate, endDate, isTemporary, osmNoteId, computedRouteId, sourceId, isValid, geometry, dropZones) {
    this.id = id;
    this.created = created;
    this.updated = updated;
    this.creator = creator;
    this.description = description;
    this.geoPoint = geoPoint;
    this.address = address;
    this.city = city;
    this.photoUrl = photoUrl;
    this.source = source;
    this.status = status;
    this.typeCode = typeCode;
    this.reviews = reviews;
    this.startDate = startDate;
    this.endDate = endDate;
    this.isTemporary = isTemporary;
    this.osmNoteId = osmNoteId;
    this.computedRouteId = computedRouteId;
    this.sourceId = sourceId;
    this.isValid = isValid;
    this.geometry = geometry;
    this.dropZones = dropZones;
    this.isClosed = this.status === 'CLOSED' || this.status === 'ARCHIVED' || this.status === 'CLOSED_BY_OSM';
    if (this.geoPoint) this.bounds = _maplibreGl.LngLatBounds.fromLngLat(new _maplibreGl.LngLat(this.geoPoint.coordinates[0], this.geoPoint.coordinates[1]), 50);else if (geometry) {
      const bounds = new _maplibreGl.LngLatBounds();
      if (geometry.type === 'MultiLineString') {
        geometry.coordinates.forEach(linestring => {
          linestring.forEach(([lng, lat]) => {
            bounds.extend([lng, lat]);
          });
        });
      } else {
        geometry.coordinates.forEach(ele => {
          ele.forEach(polygon => {
            polygon.forEach(([lng, lat]) => {
              bounds.extend([lng, lat]);
            });
          });
        });
      }
      this.bounds = bounds;
    }
  }
  get JOSMParams() {
    return this.bounds ? `left=${this.bounds.getWest()}&right=${this.bounds.getEast()}&top=${this.bounds.getNorth()}&bottom=${this.bounds.getSouth()}` : '';
  }
  get nbReviews() {
    if (!this.reviews) {
      return 0;
    }
    return this.reviews.reduce((cmp, review) => {
      if (review.comment) {
        ++cmp;
      }
      return cmp;
    }, 0);
  }
  get nbUsefulRatings() {
    return this.reviews.reduce((cmp, review) => {
      if (review.rating === Ratings.Useful) {
        ++cmp;
      }
      return cmp;
    }, 0);
  }
  get nbNotUsefulRatings() {
    return this.reviews.reduce((cmp, review) => {
      if (review.rating === Ratings.NotUseful) {
        ++cmp;
      }
      return cmp;
    }, 0);
  }
  getSignedInUserUsefulReview(userId) {
    return this.reviews?.find(({
      creator,
      rating
    }) => creator?.id === userId && rating === Ratings.Useful) || null;
  }
  getSignedInUserUnusefulReview(userId) {
    return this.reviews?.find(({
      creator,
      rating
    }) => creator?.id === userId && rating === Ratings.NotUseful) || null;
  }
  clone() {
    return new Report(this.id, this.created.clone(), this.updated.clone(), this.creator, this.description, this.geoPoint, this.address, this.city, this.photoUrl, this.source, this.status, this.typeCode, [...this.reviews], this.startDate?.clone() || null, this.endDate?.clone() || null, this.isTemporary, this.osmNoteId, this.computedRouteId, this.sourceId, this.isValid, this.geometry, [...this.dropZones]);
  }
}
exports.Report = Report;